var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
export function isSuggestionGroup(item) {
    return Object.prototype.hasOwnProperty.call(item, 'items');
}
export default class SuggestionCore extends React.PureComponent {
    BEM() {
        const classArray = ['suggestion'];
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        return classArray.join(' ');
    }
    itemBEM(item) {
        const classArray = ['suggestion__item'];
        if (isSuggestionGroup(item)) {
            classArray.push('suggestion__item--grouped');
        }
        else {
            if (item.isActive) {
                classArray.push('is-active');
            }
            if (item.isFocused) {
                classArray.push('is-focused');
            }
            if (item.color) {
                classArray.push('suggestion__item--' + item.color);
            }
            if (item.className) {
                classArray.push(item.className);
            }
        }
        return classArray.join(' ');
    }
    // Don't remove spans, they are needed if the page is translated with Google Translate
    getMarkedContent(label) {
        return (React.createElement("mark", { className: "suggestion__label-mark" },
            React.createElement("span", null, label)));
    }
    // Don't remove spans, they are needed if the page is translated with Google Translate
    generateLabel(item) {
        const { label, subLabel } = item;
        const { highlightedValue } = this.props;
        const getSubLabel = subLabel && React.createElement("span", { className: "suggestion__sub-label" }, subLabel);
        if (highlightedValue) {
            const highlightedValueIndex = label.toLowerCase().indexOf(highlightedValue.toLowerCase());
            const highlightedText = label.slice(highlightedValueIndex, highlightedValueIndex + highlightedValue.length);
            if (label.toLowerCase().includes(highlightedValue.toLowerCase())) {
                const markedLabel = label.split(highlightedText).map((part, index) => {
                    return (React.createElement(React.Fragment, { key: index },
                        React.createElement("span", null, part.split(highlightedText)[0]),
                        (label.split(highlightedText).length !== index + 1) && this.getMarkedContent(highlightedText)));
                });
                return (React.createElement("span", { className: "suggestion__label" },
                    React.createElement("span", null, markedLabel),
                    React.createElement("span", null, getSubLabel)));
            }
        }
        return (React.createElement("span", { className: "suggestion__label" },
            React.createElement("span", null, label),
            React.createElement("span", null, getSubLabel)));
    }
    getItem(item, index) {
        const { Anchor, Icon, Image } = this.props.components;
        const { label, subLabel, isActive, itemRef, icon, image, id, role, 'aria-selected': ariaSelected } = item, rest = __rest(item, ["label", "subLabel", "isActive", "itemRef", "icon", "image", "id", "role", 'aria-selected']);
        return (React.createElement("li", { className: this.itemBEM(item), ref: itemRef, key: id || index, role: role, "aria-selected": ariaSelected, id: id },
            React.createElement(Anchor, Object.assign({ isUnderlined: false }, rest, { className: "suggestion__link", tabIndex: 0 }),
                icon && React.createElement(Icon, { modifiers: icon, className: "suggestion__icon" }),
                image && React.createElement(Image, Object.assign({}, image, { className: "suggestion__image" })),
                this.generateLabel(item))));
    }
    getItems(items) {
        return items.map((item, index) => {
            if (isSuggestionGroup(item)) {
                return (React.createElement("li", { className: this.itemBEM(item), key: index },
                    React.createElement("div", { className: "suggestion__group-label" }, item.label),
                    React.createElement("ul", { className: "suggestion__group-list" }, item.items.map((groupListItem, i) => {
                        return this.getItem(groupListItem, i);
                    }))));
            }
            else {
                return this.getItem(item, index);
            }
        });
    }
    getAdditionalContent(additionalContent) {
        return (React.createElement("li", { className: "suggestion__item suggestion__item--additional-content" }, additionalContent));
    }
    getSpinner() {
        const { Spinner } = this.props.components;
        return (React.createElement("li", { className: "suggestion__item" },
            React.createElement(Spinner, { className: "suggestion__spinner" })));
    }
    render() {
        const _a = this.props, { items, listRef, isLoading, highlightedValue, additionalContent, components } = _a, rest = __rest(_a, ["items", "listRef", "isLoading", "highlightedValue", "additionalContent", "components"]);
        return (React.createElement("ul", Object.assign({}, rest, { ref: listRef, className: this.BEM() }),
            this.getItems(items),
            isLoading && this.getSpinner(),
            additionalContent && this.getAdditionalContent(additionalContent)));
    }
}
